import { Store } from "vuex";

import AuthApi from "../../plugins/AdminTemplate/Api/Auth.api";
import { errorNotificationWrapper } from "../helpers/NotificationService";
import { ChangePasswordReq, LocalChangePassword } from "./types";

const errorNotify = (error: any) => errorNotificationWrapper('', error)
const PASSWORD_MIN_SYMBOLS = '6'

function checkLogin(store: Store<any>) {
  return AuthApi.checkLogin()
    .then(({ data }) => {
      store.commit('AdminTemplate/UPDATE_USER_INFO', data)

      return data
    })
    .catch(error => {
      errorNotify(error)

      store.commit('AdminTemplate/UPDATE_USER_INFO', null)
    })
    .finally(() => {
      if (sessionStorage) {
        sessionStorage.setItem('lastCheckLogin', String(Date.now()))
      }
    })
}

function login(login: string, password: string, store: Store<any>) {
  return AuthApi.login(login, password)
    .then(res => checkLogin(store))
    .catch(errorNotify)
}

//password
async function prepareChangePassword(model: LocalChangePassword, hasPassword: boolean): Promise<ChangePasswordReq> {
  if (hasPassword) {
    return {
      target: model.target,
      current: model.current as string
    }
  } else {
    return {
      target: model.target
    }
  }
}

function changePassword(model: LocalChangePassword, hasPassword: boolean) {
  return prepareChangePassword(model, hasPassword)
    .then(res => {
      return AuthApi.changePassword(res.target, res.current)
        .then(() => {

          return model
        })
        .catch(errorNotify)
    })
    .catch(errorNotify)
}

function resetPassword(email: string) {
  return AuthApi.resetPassword(email.trim())
    .then(res => true)
    .catch(errorNotify)
}

function setPassword(email: string, hash: string) {
  return AuthApi.setPassword(email.trim(), hash)
    .then(res => true)
    .catch(errorNotify)
}

// email
function targetPasswordsEqual(target: LocalChangePassword['target'], confirmTarget: LocalChangePassword['confirmTarget']) {
  return target.trim() === confirmTarget.trim()
}

function sendEmailConfirmCode(email: string) {
  return AuthApi.sendEmailConfirmCode(email.trim())
    .then(res => true)
    .catch(errorNotify)
}

function confirmEmail(code: string) {
  return AuthApi.confirmEmail(+code.trim())
    .then(res => true)
    .catch(errorNotify)
}

export {
  login,
  checkLogin,
  targetPasswordsEqual,
  changePassword,
  resetPassword,
  setPassword,
  sendEmailConfirmCode,
  confirmEmail,
  PASSWORD_MIN_SYMBOLS
}

